import React from 'react';
import { translate } from '../../Services/translation';
import { storeIdConverter } from '../../Services/StoreId.service';

export const StoreSmallItemView = ({ store }) => {    
    const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);
    const prettyPhoneNumber = prettifyNumber(store.storePhone);

    return <div className="store__smallitem" data-storeid={store.storeId} data-storename={store.storeName}>
        <div className="store__smallitem-title">
            <a href={store.urlToStore} className="store-link">
                <span>{store.storeName}</span>
            </a>
        </div>
        <div className="store__smallitem-address">
            {store.storeAddress}
        </div>
        <div className="store__smallitem-phone"><a  onClick={() => { 
            window.location=`tel:${prettyPhoneNumber}`}
        }>{prettyPhoneNumber}</a></div>        
        <div className="store__smallitem-openHours">
            {store && store.additionalStoreData && store.additionalStoreData.openingHours && store.additionalStoreData.openingHours.map(({ day, opening, closing, text }, index) => <div className="item" key={`store__smallitem-openHours ${day} ${opening} ${closing} ${text} ${index}`}>
                <span className="label">{capitalize(day)}:</span>
                <span className="value">{text ? text : `${new Date(opening).getHours().toString().padStart(2, '0')}:${new Date(opening).getMinutes().toString().padStart(2, '0')} - ${new Date(closing).getHours().toString().padStart(2, '0')}:${new Date(closing).getMinutes().toString().padStart(2, '0')}`}</span>
            </div>)}
        </div>
        {store && store.storeId ? <a href={`${window.__litium.baseBookingUrl}?current_optician=${storeIdConverter(store.storeId).asNumber}`} className="store__smallitem-orderlink">{translate('homepage_bookingappointment.buttontext')}</a> : null}
    </div>;
}

export const prettifyNumber = (num) => num && num.toString().replace(/(\d{1,2}(?=(?:\d\d)+(?!\d)))/g, "$1" + " ");
